export default class ProgressController{
	constructor(){
		this.progressBars = Array.from(document.querySelectorAll('.js-progress-bar'));
		this.main = document.querySelector('main');
		this.header = document.querySelector('header');
		this.eventTriggered = ::this.eventTriggered;
		this.initEvents();
	}

	getHeight(element){
		return element.getBoundingClientRect().height;
	}

	getTopOffset(element){
		return element.getBoundingClientRect().top;
	}

	eventTriggered(e){
		const mainHeight = this.getHeight(this.main);
		const headerHeight = this.getHeight(this.header);
		const mainTopOffset = this.getTopOffset(this.main);

		if(mainTopOffset < headerHeight){
			const progress = (Math.abs(mainTopOffset - headerHeight) / (mainHeight - window.innerHeight));
			this.progressBars.forEach( bar => {
				bar.style.transform = `scaleX(${progress})`;
			});
		}else{
			this.progressBars.forEach( bar => {
				bar.removeAttribute('style');
			});
		}
	}

	initEvents(){
		window.addEventListener('scroll', this.eventTriggered);
		window.addEventListener('resize', this.eventTriggered);
	}
}


// WEBPACK FOOTER //
// ./Components/ProgressController.js